// Auto-generated
export const easeIn = 'cubic-bezier(0.4, 0, 1, 1)';
export const easeOut = 'cubic-bezier(0, 0, 0.2, 1)';
export const easeInOut = 'cubic-bezier(0.4, 0, 0.2, 1)';
export const linear = 'cubic-bezier(0, 0, 1, 1)';
